var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMediaFacebook = function SvgMediaFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#4367B0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.416 12v3.592h-1.691a.744.744 0 0 0-.63.443c-.13.268-.196.57-.196.909v2.24h2.517v3.633h-2.517V30h-3.382v-7.183H17v-3.634h2.517v-3.591c.026-1.014.354-1.86.983-2.536.63-.676 1.429-1.028 2.399-1.056h2.517Z"
  })));
};
export default SvgMediaFacebook;